module.exports = __webpack_public_path__ + "img/img-text.9a195964.svg";